import {TextField} from "@mui/material";
import {DatePicker, LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns";
import ko from "date-fns/locale/ko";
import {Controller, useFormContext} from "react-hook-form";

type InputDateType = {
  name: string;
};

const MWInputDate = ({name}: InputDateType) => {
  const methods = useFormContext();

  const {control} = methods;

  return (
    <Controller
      name={name}
      control={control}
      render={({field, ...props}) => (
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ko}>
          <DatePicker
            inputFormat={"yyyy년 MM월 dd일"}
            value={field.value}
            onChange={(date) => {
              if (!date) return field.onChange(null);

              const fixed = new Date(
                date.getFullYear(),
                date.getMonth(),
                date.getDate(),
                9,
                0,
                0 // 한국: UTC+9 → 9시로 고정
              );

              field.onChange(fixed);
            }}
            renderInput={(params) => <TextField {...params} id={name} size="small" />}
          />
        </LocalizationProvider>
      )}
    />
  );
};

export default MWInputDate;
